import { render, staticRenderFns } from "./AddBadwordToBlacklistModal.vue?vue&type=template&id=0298536f"
import script from "./AddBadwordToBlacklistModal.vue?vue&type=script&lang=js"
export * from "./AddBadwordToBlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports